<div class="grid">
  <div class="col-12">
    <div class="card">
      <p-table #dt
               [value]="users"
               dataKey="id"
               [rows]="10"
               [loading]="loading"
               [rowHover]="true"
               styleClass="p-datatable-gridlines"
               [paginator]="true"
               responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="flex justify-content-right flex-column sm:flex-row">
            <button pButton
                    label="Clear"
                    class="p-button-outlined mb-2 mr-2"
                    icon="pi pi-filter-slash"
                    (click)="clear(dt)"></button>
<!--            <button type="button"-->
<!--                    pButton-->
<!--                    pRipple-->
<!--                    icon="pi pi-filter"-->
<!--                    (click)="dt.exportCSV({ selectionOnly: true })"-->
<!--                    class="p-button-info ml-auto"-->
<!--                    pTooltip="Selection Only"-->
<!--                    tooltipPosition="bottom"></button>-->

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>
              <div class="flex justify-content-between align-items-center">
                Email
                <p-columnFilter type="text"
                                field="email"
                                display="menu"
                                placeholder="Email"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Prénom
                <p-columnFilter type="text"
                                field="firstname"
                                display="menu"
                                placeholder="Prénom"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Nom
                <p-columnFilter type="text"
                                field="nom"
                                display="menu"
                                placeholder="Nom"></p-columnFilter>
              </div>
            </th>

            <th>
              <div class="flex justify-content-between align-items-center">
                Roles
                <p-columnFilter type="text"
                                field="roles"
                                display="menu"
                                placeholder="Roles"></p-columnFilter>
              </div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body"
                     let-user>
          <tr>
            <td style="min-width: 12rem;">
              {{user.email}}
            </td>

            <td style="min-width: 12rem;">

              {{user.firstname}}
            </td>

            <td style="min-width: 12rem;">
              {{user.lastname}}
            </td>

            <td style="min-width: 12rem;">
              {{user.roles}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
